import { useEffect } from "react";
import { useAppSelector } from "../redux/hooks";
import { getCommonState } from "../redux/store/getState";
import deepSearch from "../utils/deepSearch";

export default function useSearch(searchData: any, setData: any) {
  const {
    headerSearch: { value },
  } = useAppSelector(getCommonState);

  useEffect(() => {
    if (value) {
      setData(deepSearch(searchData, value));
    } else {
      setData(searchData);
    }
  }, [value, searchData, setData]);

  return null;
}
